import { render, staticRenderFns } from "./3BankVerification.vue?vue&type=template&id=0bac5282&scoped=true"
import script from "./3BankVerification.vue?vue&type=script&lang=js"
export * from "./3BankVerification.vue?vue&type=script&lang=js"
import style0 from "./3BankVerification.vue?vue&type=style&index=0&id=0bac5282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac5282",
  null
  
)

export default component.exports